export default {
    'name': 'clms',
    'label': 'patent-view.CLMS',
    'getComponent': () => import('./clms.vue'),
    'tabIndex': 1,
    'left': true,
    'right': true,
    'singleView': true,
    'compareView': true,
    'exclusiveRoutePath': '/clms',
    'enableDensity': true,
};
